import { InjectionToken } from '@angular/core';
import { _ } from '@ngx-translate/core';
import { environment } from '@src/environments/environment';

import { NavigationItem, NavigationTree } from './types';

export const NAVIGATION_ITEMS_TOKEN = new InjectionToken<NavigationItem[]>('NAVIGATION.ITEMS');

export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    id: 'menu.info',
    icon: 'menu',
    title: _('components.navigation.constants.navigationItems.infoTitle'),
    link: '/info',
    permissions: ['pageInfoViewing'],
    mobileOnly: true,
  },
  {
    id: 'menu.association',
    icon: 'landmark',
    title: _('components.navigation.constants.navigationItems.associationTitle'),
    link: '/association',
    permissions: ['pageAssociationViewing'],
  },
  {
    id: 'menu.organisations',
    icon: 'building-2',
    title: _('components.navigation.constants.navigationItems.organisationsTitle'),
    link: '/association-organisations',
    permissions: ['pageAssociationOrganisationsViewing'],
  },
  {
    id: 'menu.users',
    icon: 'users',
    title: _('components.navigation.constants.navigationItems.usersTitle'),
    link: '/association-users',
    permissions: ['pageAssociationUsersViewing'],
  },
  {
    id: 'menu.committees',
    icon: 'network',
    title: _('components.navigation.constants.navigationItems.committeesTitle'),
    link: '/committees',
    permissions: ['pageCommitteesViewing'],
  },
  {
    id: 'menu.chats',
    title: _('components.navigation.constants.navigationItems.chatsTitle'),
    icon: 'send',
    link: '/chats',
    permissions: ['pageChatsViewing'],
  },
  {
    id: 'menu.chatsInner',
    title: _('components.navigation.constants.navigationItems.chatsInnerTitle'),
    icon: 'message-square-more',
    link: '/chats-inner',
    permissions: ['pageChatsInnerViewing'],
  },
  {
    id: 'menu.chatPublic',
    title: _('components.navigation.constants.navigationItems.chatPublicTitle'),
    icon: 'radio',
    link: '/chat-public',
    permissions: ['pageChatPublicViewing'],
  },
  {
    id: 'menu.loyalty',
    title: _('components.navigation.constants.navigationItems.loyaltyTitle'),
    icon: 'book',
    link: '/loyalty',
    permissions: ['pageLoyaltyViewing'],
  },
  {
    id: 'menu.events',
    title: _('components.navigation.constants.navigationItems.eventsTitle'),
    icon: 'calendar',
    link: '/events',
    permissions: ['pageEventsViewing'],
  },
  {
    id: 'menu.polls',
    title: _('components.navigation.constants.navigationItems.pollsTitle'),
    icon: 'bar-chart-2',
    link: '/polls',
    permissions: ['pagePollsViewing'],
  },
  {
    id: 'menu.mailing',
    title: _('components.navigation.constants.navigationItems.newsletterTitle'),
    icon: 'mail',
    badge: 'beta',
    link: '/newsletter',
    permissions: ['pageNewsletterViewing'],
  },
  {
    id: 'menu.newsFeed',
    title: _('components.navigation.constants.navigationItems.newsFeedTitle'),
    icon: 'radio',
    link: '/news-feed',
    permissions: ['pageNewsFeedViewing'],
  },
  // TODO: пока не показываем КЦ. удалить когда доделаем КЦ
  !!environment.featureFlags?.cooperationChainsEnabled
    ? {
        id: 'menu.cooperationChains',
        title: _('components.navigation.constants.navigationItems.cooperationChainsTitle'),
        description: _('components.navigation.constants.navigationItems.cooperationChainsDescription'),
        icon: 'square-stack',
        link: '/cooperation-chains',
        permissions: ['pageCooperationChainsViewing'],
      }
    : ({} as NavigationItem),
  {
    id: 'menu.settings',
    title: _('components.navigation.constants.navigationItems.settingsTitle'),
    description: _('components.navigation.constants.navigationItems.settingsDescription'),
    icon: 'settings',
    link: '/settings',
    permissions: ['pageSettingsViewing'],
  },
  {
    id: 'menu.organisation',
    title: _('components.navigation.constants.navigationItems.organisationTitle'),
    description: _('components.navigation.constants.navigationItems.organisationDescription'),
    icon: 'building',
    link: '/organisation',
    permissions: ['pageOrganisationViewing'],
  },
  {
    id: 'menu.profile',
    title: _('components.navigation.constants.navigationItems.profileTitle'),
    description: _('components.navigation.constants.navigationItems.profileDescription'),
    icon: 'user',
    link: 'profile',
    permissions: ['pageProfileViewing'],
  },
  {
    id: 'menu.folders',
    title: _('components.navigation.constants.navigationItems.foldersTitle'),
    description: _('components.navigation.constants.navigationItems.foldersDescription'),
    icon: 'folders',
    link: '/settings/folders',
    permissions: ['pageChatsViewing'],
  },
  {
    id: 'menu.preferences',
    title: _('components.navigation.constants.navigationItems.preferencesTitle'),
    icon: 'table',
    link: '/settings/preferences',
    permissions: ['pageSettingsPreferencesViewing'],
  },
  {
    id: 'menu.notifications',
    title: _('components.navigation.constants.navigationItems.notificationsTitle'),
    icon: 'bell-ring',
    link: 'notifications',
    permissions: ['pageSettingsNotificationsViewing'],
  },
  {
    id: 'menu.administration',
    title: _('components.navigation.constants.navigationItems.administrationTitle'),
    description: _('components.navigation.constants.navigationItems.administrationDescription'),
    icon: 'shield-check',
    link: '/settings/administration',
    permissions: ['pageAdministrationViewing'],
  },
  {
    id: 'menu.language',
    title: _('components.navigation.constants.navigationItems.languageTitle'),
    icon: 'languages',
    link: 'language',
  },
  {
    id: 'menu.theme',
    title: _('components.navigation.constants.navigationItems.themeTitle'),
    icon: 'sun',
    link: 'theme',
  },
  {
    id: 'menu.version',
    title: _('components.navigation.constants.navigationItems.versionTitle'),
    description: environment.appVersion,
    icon: 'hash',
    link: '/settings/changelog',
  },
  {
    id: 'menu.support',
    title: _('components.navigation.constants.navigationItems.supportTitle'),
    icon: 'help-circle',
    link: 'support',
  },
  {
    id: 'menu.documents',
    title: _('components.navigation.constants.navigationItems.documentsTitle'),
    icon: 'shield',
    link: 'documents',
  },
  {
    id: 'menu.licenses',
    title: _('components.navigation.constants.navigationItems.licensesTitle'),
    icon: 'copyright',
    link: '/settings/licenses',
  },
  {
    id: 'menu.logout',
    title: _('components.navigation.constants.navigationItems.logoutTitle'),
    description: _('components.navigation.constants.navigationItems.logoutDescription'),
    icon: 'log-out',
  },
  {
    id: 'menu.curator',
    title: _('components.navigation.constants.navigationItems.curatorTitle'),
    icon: 'user',
    permissions: ['curatorButtonViewing'],
  },
  {
    id: 'menu.cc-suppliers',
    title: _('components.navigation.constants.navigationItems.CcSuppliersTitle'),
    icon: 'table',
    link: '/cooperation-chains/suppliers',
    permissions: ['pageCooperationChainsViewing'],
  },
  {
    id: 'menu.cc-configuration',
    title: _('components.navigation.constants.navigationItems.CcConfigurationTitle'),
    icon: 'table',
    link: '/cooperation-chains/configuration',
    permissions: ['pageCooperationChainsViewing'],
  },
  {
    id: 'menu.cc-analysis',
    title: _('components.navigation.constants.navigationItems.CcAnalysisTitle'),
    icon: 'table',
    link: '/cooperation-chains/analysis',
    permissions: ['pageCooperationChainsViewing'],
  },
  {
    id: 'menu.cc-dictionaries',
    title: _('components.navigation.constants.navigationItems.CcDictionariesTitle'),
    icon: 'table',
    link: '/cooperation-chains/dictionaries',
    permissions: ['pageCooperationChainsViewing'],
  },
  {
    id: 'menu.cc-configuration-dictionaries',
    title: _('components.navigation.constants.navigationItems.CcConfigurationDictionariesTitle'),
    icon: 'settings',
    link: '/cooperation-chains/configuration-dictionaries',
    permissions: ['pageCooperationChainsViewing'],
  },

  {
    id: 'menu.administrationNewUsers',
    icon: 'users',
    title: _('components.administration.labels.menuNewUsers'),
    link: '/settings/administration/new-users',
    permissions: ['pageAdministrationViewing'],
  },
  {
    id: 'menu.administrationModerationUsers',
    icon: 'users',
    title: _('components.administration.labels.menuModerationUsers'),
    link: '/settings/administration/moderation-users',
    permissions: ['pageAdministrationViewing'],
  },
  {
    id: 'menu.administrationNewAssociation',
    icon: 'circle-plus',
    title: _('components.administration.labels.menuNewAssociation'),
    link: '/settings/administration/new-association',
    permissions: ['associationCreating'],
  },
  {
    id: 'menu.administrationCustomNames',
    icon: 'file-pen-line',
    title: _('components.administration.labels.menuCustomNames'),
    link: '/settings/administration/custom-names',
    permissions: ['pageAdministrationViewing'],
  },
  {
    id: 'menu.administrationSelectJobTitles',
    icon: 'circle-check',
    title: _('components.administration.labels.menuSelectJobTitles'),
    link: '/settings/administration/select-job-titles',
    permissions: ['pageAdministrationViewing'],
  },
  {
    id: 'menu.administrationSelectBusinessTypes',
    icon: 'circle-check',
    title: _('components.administration.labels.menuSelectBusinessTypes'),
    link: '/settings/administration/select-business-types',
    permissions: ['pageAdministrationViewing'],
  },
  {
    id: 'menu.administrationContactsDirectory',
    icon: 'book-text',
    title: _('components.administration.labels.menuContactsDirectory'),
    link: '/settings/administration/contacts-directory',
    permissions: ['pageAdministrationViewing'],
  },
  {
    id: 'menu.administrationImport',
    icon: 'upload',
    title: _('components.administration.labels.menuImport'),
    link: '/settings/administration/import',
    permissions: ['importViewing'],
  },
  {
    id: 'menu.administrationMail',
    icon: 'mail',
    title: _('components.administration.labels.menuMail'),
    link: '/settings/administration/mail',
    permissions: ['pageAdministrationViewing'],
  },
  {
    id: 'menu.administrationReports',
    icon: 'file',
    title: _('components.administration.labels.menuReports'),
    link: '/settings/administration/reports',
    permissions: ['pageAdministrationViewing'],
  },
  {
    id: 'menu.administrationPages',
    icon: 'file-text',
    title: _('components.administration.labels.menuPages'),
    link: '/settings/administration/pages',
    permissions: ['pageAdministrationViewing'],
  },
  {
    id: 'menu.administrationStandardUserInfoFields',
    icon: 'user-cog',
    title: _('components.administration.labels.menuStandardUserInfoFields'),
    link: '/settings/administration/standard-user-info-fields',
    permissions: ['pageAdministrationViewing'],
  },
  {
    id: 'label.committeeInfo',
    icon: 'info',
    title: _('components.committee.labels.menuInfo'),
    link: '.',
    queryParams: { menu: 'info' },
  },
  {
    id: 'label.committeeMembers',
    icon: 'users',
    title: _('components.committee.labels.menuUsers'),
    link: '.',
    queryParams: { menu: 'users' },
  },
  {
    id: 'label.committeeChats',
    icon: 'radio',
    title: _('components.committee.labels.menuChannels'),
    link: '.',
    queryParams: { menu: 'channels' },
  },
  {
    id: 'label.committeePolls',
    icon: 'bar-chart-2',
    title: _('components.committee.labels.menuPolls'),
    link: '.',
    queryParams: { menu: 'polls' },
  },
  {
    id: 'label.organisationInfo',
    icon: 'info',
    title: _('components.organisation.labels.menuInfo'),
    link: '.',
    queryParams: { menu: 'info' },
  },
  {
    id: 'label.organisationMembers',
    icon: 'users',
    title: _('components.organisation.labels.menuUsers'),
    link: '.',
    queryParams: { menu: 'users' },
  },
  {
    id: 'label.organisationChats',
    icon: 'send',
    title: _('components.organisation.labels.menuChannels'),
    link: '.',
    queryParams: { menu: 'channels' },
  },
  {
    id: 'label.organisationCommittees',
    icon: 'network',
    title: _('components.organisation.labels.menuCommittees'),
    link: '.',
    queryParams: { menu: 'committees' },
  },
  {
    id: 'configs',
    icon: 'settings',
    title: _('components.organisation.labels.menuConfigs'),
    link: '.',
    queryParams: { menu: 'settings' },
  },
];

export const DESKTOP_NAVIGATION: NavigationTree[] = [
  { itemName: 'menu.association' },
  { itemName: 'menu.organisations' },
  { itemName: 'menu.users' },
  { itemName: 'menu.committees' },
  { itemName: 'menu.chats' },
  { itemName: 'menu.chatsInner' },
  { itemName: 'menu.chatPublic' },
  { itemName: 'menu.loyalty' },
  { itemName: 'menu.events' },
  { itemName: 'menu.polls' },
  { itemName: 'menu.mailing' },
  { itemName: 'menu.newsFeed' },
  { itemName: 'menu.cooperationChains' },
  { itemName: 'menu.settings' },
  { itemName: 'menu.curator' },
];

export const MOBILE_NAVIGATION: NavigationTree[] = [
  { itemName: 'menu.info' },
  { itemName: 'menu.chatsInner' },
  { itemName: 'menu.events' },
  { itemName: 'menu.polls' },
  { itemName: 'menu.chatPublic' },
];

export const INFO_NAVIGATION: NavigationTree[] = [
  { itemName: 'menu.association' },
  { itemName: 'menu.organisations' },
  { itemName: 'menu.users' },
  { itemName: 'menu.loyalty' },
  { itemName: 'menu.committees' },
  { itemName: 'menu.chats' },
  { itemName: 'menu.newsFeed' },
  { itemName: 'menu.mailing' },
  { itemName: 'menu.cooperationChains' },
  { itemName: 'menu.settings' },
  { itemName: 'menu.curator' },
];

export const SETTINGS_NAVIGATION: NavigationTree[] = [
  { itemName: 'menu.profile' },
  { itemName: 'menu.folders' },
  { itemName: 'menu.preferences' },
  { itemName: 'menu.mail' },
  { itemName: 'menu.notifications' },
  { itemName: 'menu.administration' },
  { itemName: 'menu.language' },
  { itemName: 'menu.theme' },
  { itemName: 'menu.version' },
  { itemName: 'menu.support' },
  { itemName: 'menu.documents' },
  { itemName: 'menu.licenses' },
  { itemName: 'menu.logout' },
];

export const ONLY_LP_SETTINGS_NAVIGATION: NavigationTree[] = [
  { itemName: 'menu.loyalty' },
  { itemName: 'menu.profile' },
  { itemName: 'menu.language' },
  { itemName: 'menu.theme' },
  { itemName: 'menu.support' },
  { itemName: 'menu.documents' },
  { itemName: 'menu.logout' },
];

export const COOPERATION_CHAINS_NAVIGATION: NavigationTree[] = [
  { itemName: 'menu.cc-suppliers' },
  { itemName: 'menu.cc-configuration' },
  { itemName: 'menu.cc-analysis' },
  { itemName: 'menu.cc-dictionaries' },
  { itemName: 'menu.cc-configuration-dictionaries' },
];

export const ADMINISTRATION_NAVIGATION: NavigationTree[] = [
  { itemName: 'menu.administrationNewUsers' },
  { itemName: 'menu.administrationModerationUsers' },
  { itemName: 'menu.administrationNewAssociation' },
  { itemName: 'menu.administrationCustomNames' },
  { itemName: 'menu.administrationSelectJobTitles' },
  { itemName: 'menu.administrationSelectBusinessTypes' },
  { itemName: 'menu.administrationContactsDirectory' },
  { itemName: 'menu.administrationImport' },
  { itemName: 'menu.administrationMail' },
  { itemName: 'menu.administrationReports' },
  { itemName: 'menu.administrationPages' },
  { itemName: 'menu.administrationStandardUserInfoFields' },
];

export const COMMITTEE_NAVIGATION: NavigationTree[] = [
  { itemName: 'label.committeeInfo' },
  { itemName: 'label.committeeMembers' },
  { itemName: 'label.committeeChats' },
  { itemName: 'menu.events', link: '.', queryParams: { menu: 'events' }, permissions: [] },
  { itemName: 'label.committeePolls' },
  { itemName: 'configs', permissions: ['committeeConfigsViewing'] },
];

export const ORGANISATION_NAVIGATION: NavigationTree[] = [
  { itemName: 'label.organisationInfo' },
  { itemName: 'label.organisationMembers' },
  { itemName: 'label.organisationChats' },
  { itemName: 'label.organisationCommittees' },
  { itemName: 'configs', permissions: ['organisationConfigsViewing'] },
];
